import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

//BACKEND_BASE_URL = 'https://ft-cloud-run-200839435575.us-central1.run.app';
// const BACKEND_BASE_URL = 'https://ft-cloud-run-200839435575.us-central1.run.app';
const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_SERVER_URL || "http://127.0.0.1:8000";

function createFormData(user) {
  const formData = new FormData();
  for (const key in user) {
    if (user.hasOwnProperty(key)) {
      formData.append(key, user[key]);
    }
  }
  return formData;
}

export const userAuthApi = createApi({
  reducerPath: 'userAuthApi',
  //base url is backend_base_url + /api/user/
  baseQuery: fetchBaseQuery({ baseUrl: BACKEND_BASE_URL + '/api/user/' }),
  endpoints: (builder) => ({
    // User registration endpoint
    registerUser: builder.mutation({
      query: (userData) => {
        return {
          url: 'register/',
          method: 'POST',
          body: userData,
          headers: {
            'Content-type': 'application/json',
          }
        }
      }
    }),
    
    // New user registration verification endpoint
    registerVerification: builder.mutation({
      query: (userData) => {
        return {
          url: 'register-verification/',
          method: 'POST',
          body: userData,
          headers: {
            'Content-type': 'application/json',
          }
        }
      }
    }),
    
    // User login endpoint
    loginUser: builder.mutation({
      query: (user) => {
        return {
          url: 'login/',
          method: 'POST',
          body: user,
          headers: {
            'Content-type': 'application/json'
          }
        }
      }
    }),
    
    // Get logged in user profile
    getLoggedUser: builder.query({
      query: (access_token) => {
        return {
          url: 'profile/',
          method: 'GET',
          headers: {
            'authorization': `Bearer ${access_token}`
          }
        }
      }
    }),
    
    // Change user password
    changeUserPassword: builder.mutation({
      query: ({actualData, access_token}) => {
        return {
          url: 'changepassword/',
          method: 'POST',
          body: actualData,
          headers: {
            'authorization': `Bearer ${access_token}`
          }
        }
      }
    }),
    
    // Password reset email - Request a verification code
    sendPasswordResetEmail: builder.mutation({
      query: (user) => {
        return {
          url: 'send-reset-password-email/',
          method: 'POST',
          body: user,
          headers: {
            'Content-type': 'application/json'
          }
        }
      }
    }),

    // Verify password reset code
    verifyPasswordResetCode: builder.mutation({
      query: (verificationData) => {
        return {
          url: 'verify-reset-code/',
          method: 'POST',
          body: verificationData,
          headers: {
            'Content-type': 'application/json',
          }
        }
      }
    }),

    // Reset password with verification code
    resetPasswordConfirm: builder.mutation({
      query: (resetData) => {
        return {
          url: 'reset-password-confirm/',
          method: 'POST',
          body: resetData,
          headers: {
            'Content-type': 'application/json',
          }
        }
      }
    }),

    // Verify email code endpoint
    verifyCode: builder.mutation({
      query: (verificationData) => {
        return {
          url: 'verify-email/',
          method: 'POST',
          body: verificationData,
          headers: {
            'Content-type': 'application/json',
          }
        }
      }
    }),
  }),
})

// Export all hooks for the userAuthApi
export const { 
  useRegisterUserMutation,
  useRegisterVerificationMutation,
  useLoginUserMutation, 
  useGetLoggedUserQuery, 
  useChangeUserPasswordMutation,
  useSendPasswordResetEmailMutation, 
  useVerifyCodeMutation,
  useVerifyPasswordResetCodeMutation,
  useResetPasswordConfirmMutation
} = userAuthApi

// Student API
export const userStudentApi = createApi({
  reducerPath: 'userStudentApi',
  baseQuery: fetchBaseQuery({ baseUrl: BACKEND_BASE_URL + '/api/student/' }),
  endpoints: (builder) => ({
    studentAdmission: builder.mutation({
      query: (user) => {
        const formData = createFormData(user)
        return {
          url: 'studentinfo/',
          method: 'POST',
          body: formData,
        };
      },
    }),

    studentAdmissionGet: builder.query({
      query: (user) => {
        return {
          url: 'studentinfo-get/', 
          method: 'GET', 
        };
      },
    }),
  }),
})

export const { useStudentAdmissionMutation, useStudentAdmissionGetQuery } = userStudentApi;